import { useEffect } from 'react'
import Cookies from 'universal-cookie'
import { Hub } from '@aws-amplify/core'
const cookies = new Cookies()

const shouldRemove = (cookie) => !/cookieyes|cky-consent|Cognito/.test(cookie)

const removeCookies = () => Object.keys(cookies.getAll()).forEach(cookie => {
  if (shouldRemove(cookie)) {
    cookies.remove(cookie)
  }
})

const clearLocalStorage = () => {
  const whitelist = ['after-auth-location']
  const keys = Object.keys(localStorage)

  for (const key of keys) {
    if (!whitelist.includes(key)) {
      localStorage.removeItem(key)
    }
  }
}

const cleanData = () => {
  removeCookies()
  clearLocalStorage()
}

/**
 * Clean Prime cookies to prevent unexpected behaviours
 */
const useCleanCookies = () => {
  useEffect(() => {
    const unsubscribe = Hub.listen('auth', ({ payload: { event, data } }) => {
      switch (event) {
        case 'signIn':
          cleanData()
          break
        case 'signUp':
          cleanData()
          break
        default:
      }
    })

    return unsubscribe
  }, [])
}

export default useCleanCookies
